import React, { useEffect } from 'react';
import useResultsItems from '@Containers/Summary/hooks/useResultsItems';
import { trackReferencePreview } from '@Containers/Summary/analytics';
import ReferenceCitationDetails from './ReferenceCitationDetails';

function ReferencePreview({ index, citation, onDocumentDetailsClick, metadata }) {
  const resultsItems = useResultsItems();

  useEffect(() => {
    const { id } = citation || {};
    const resultItem = resultsItems?.find((resultsItem) => resultsItem.id === id);
    trackReferencePreview({ citationFromSummary: citation, citationFromResultsList: resultItem });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citation]);

  return (
    <section>
      <h4 className="u-els-margin-bottom-2x">Reference preview</h4>
      <p className="u-els-margin-bottom-1o2">Reference {index > 0 ? index : ''}</p>
      <ReferenceCitationDetails index={index} citation={citation} onDocumentDetailsClick={onDocumentDetailsClick} metadata={metadata} />
    </section>
  );
}

export default ReferencePreview;
